(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opgeladen-appointment"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DOW_SHORT = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];
    var DOW_FULL = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
    var MON_SHORT = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
    var MON_FULL = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];

    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function ymd(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
    function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

    function parseBlocked(raw) {
      var set = {};
      if (!raw) return set;
      raw.split(/\r?\n/).forEach(function (line) {
        var m = line.trim().match(/(\d{4})-(\d{2})-(\d{2})[ T](\d{1,2}):(\d{2})/);
        if (m) set[m[1] + '-' + m[2] + '-' + m[3] + 'T' + pad(parseInt(m[4], 10)) + ':' + m[5]] = true;
      });
      return set;
    }

    function buildDays(cfg) {
      var now = new Date();
      var minTime = now.getTime() + (cfg.noticeHours || 0) * 3600000;
      var blocked = parseBlocked(cfg.blocked);
      var days = [];
      for (var offset = 0; offset < cfg.daysAhead; offset++) {
        var date = new Date(now.getFullYear(), now.getMonth(), now.getDate() + offset);
        var dow = date.getDay();
        if (!cfg.weekends && (dow === 0 || dow === 6)) continue;
        var slots = [];
        for (var mins = cfg.startHour * 60; mins + cfg.stepMin <= cfg.endHour * 60; mins += cfg.stepMin) {
          var h = Math.floor(mins / 60), mi = mins % 60;
          var dt = new Date(date.getFullYear(), date.getMonth(), date.getDate(), h, mi, 0, 0);
          var key = ymd(date) + 'T' + pad(h) + ':' + pad(mi);
          var disabled = dt.getTime() < minTime || blocked[key] === true;
          slots.push({ h: h, mi: mi, label: pad(h) + ':' + pad(mi), disabled: disabled, blocked: blocked[key] === true });
        }
        var hasFree = slots.some(function (s) { return !s.disabled; });
        if (!hasFree) continue;
        days.push({ date: date, dow: dow, offset: offset, slots: slots });
      }
      return days;
    }

    function humanReadable(date, slot) {
      return cap(DOW_FULL[date.getDay()]) + ' ' + date.getDate() + ' ' + MON_FULL[date.getMonth()] +
        ' ' + date.getFullYear() + ' om ' + slot.label + ' (Nederlandse tijd)';
    }

    function initAppt(root) {
      if (!root || root.dataset.ogApptInit === '1') return;
      var cfgEl = root.querySelector('[data-og-appt-config]');
      var dialog = root.querySelector('[data-og-appt-dialog]');
      if (!cfgEl || !dialog) return;
      root.dataset.ogApptInit = '1';

      var cfg;
      try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

      var storeKey = 'ogAppt:' + root.id;
      var daysEl = root.querySelector('[data-og-appt-days]');
      var slotsEl = root.querySelector('[data-og-appt-slots]');
      var emptyEl = root.querySelector('[data-og-appt-slots-empty]');
      var nextBtn = root.querySelector('[data-og-appt-next]');
      var slotField = root.querySelector('[data-og-appt-slotfield]');
      var summaryEl = root.querySelector('[data-og-appt-summary]');
      var summaryText = root.querySelector('[data-og-appt-summary-text]');
      var form = root.querySelector('.og-appt__form');
      var hp = root.querySelector('[data-og-appt-hp]');
      var successEl = root.querySelector('[data-og-appt-success]');
      var errorsEl = root.querySelector('[data-og-appt-errors]');

      var days = daysEl ? buildDays(cfg) : [];
      var activeDayIdx = -1;
      var chosen = null;

      function views(step) {
        var all = root.querySelectorAll('[data-og-appt-view]');
        for (var i = 0; i < all.length; i++) all[i].hidden = all[i].getAttribute('data-og-appt-view') !== String(step);
      }

      function renderSlots(day) {
        if (!slotsEl) return;
        slotsEl.innerHTML = '';
        day.slots.forEach(function (slot) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'og-appt__slot';
          b.textContent = slot.label;
          b.setAttribute('aria-pressed', 'false');
          if (slot.disabled) {
            b.disabled = true;
            b.title = slot.blocked ? 'Al gereserveerd' : 'Niet meer beschikbaar';
          } else {
            b.addEventListener('click', function () {
              var prev = slotsEl.querySelector('.og-appt__slot[aria-pressed="true"]');
              if (prev) prev.setAttribute('aria-pressed', 'false');
              b.setAttribute('aria-pressed', 'true');
              chosen = { date: day.date, slot: slot, human: humanReadable(day.date, slot) };
              if (nextBtn) nextBtn.disabled = false;
            });
          }
          slotsEl.appendChild(b);
        });
      }

      function selectDay(idx) {
        activeDayIdx = idx;
        chosen = null;
        if (nextBtn) nextBtn.disabled = true;
        var chips = daysEl.querySelectorAll('.og-appt__day');
        for (var i = 0; i < chips.length; i++) chips[i].setAttribute('aria-pressed', i === idx ? 'true' : 'false');
        renderSlots(days[idx]);
      }

      function renderDays() {
        if (!daysEl) return;
        daysEl.innerHTML = '';
        if (!days.length) {
          if (emptyEl) { emptyEl.textContent = 'Er zijn op dit moment geen momenten beschikbaar. Mail ons gerust.'; slotsEl.appendChild(emptyEl); }
          return;
        }
        days.forEach(function (day, idx) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'og-appt__day';
          b.setAttribute('aria-pressed', 'false');
          var top = day.offset === 0 ? 'Vandaag' : (day.offset === 1 ? 'Morgen' : cap(DOW_SHORT[day.dow]));
          b.innerHTML = '<span class="og-appt__day-dow">' + top + '</span>' +
            '<span class="og-appt__day-date">' + day.date.getDate() + ' ' + MON_SHORT[day.date.getMonth()] + '</span>';
          b.addEventListener('click', function () { selectDay(idx); });
          daysEl.appendChild(b);
        });
      }

      function goToDetails() {
        if (!chosen) return;
        if (slotField) slotField.value = chosen.human;
        if (summaryText) summaryText.textContent = chosen.human;
        if (summaryEl) summaryEl.hidden = false;
        try { sessionStorage.setItem(storeKey, chosen.human); } catch (e) {}
        views(2);
      }

      if (nextBtn) nextBtn.addEventListener('click', goToDetails);

      var editBtn = root.querySelector('[data-og-appt-edit]');
      if (editBtn) editBtn.addEventListener('click', function () { views(1); });

      if (form) {
        form.addEventListener('submit', function (e) {
          if (hp && hp.value) { e.preventDefault(); return; }
          if (slotField && !slotField.value && chosen) slotField.value = chosen.human;
          if (slotField && !slotField.value) {
            e.preventDefault();
            views(1);
            return;
          }
        });
      }

      function openDialog() {
        if (typeof dialog.showModal !== 'function') { dialog.setAttribute('open', ''); return; }
        if (!dialog.open) dialog.showModal();
        document.body.style.overflow = 'hidden';
        var firstDay = daysEl && daysEl.querySelector('.og-appt__day');
        if (firstDay && !successEl && !errorsEl) firstDay.focus();
      }

      function closeDialog() {
        if (dialog.open) dialog.close(); else dialog.removeAttribute('open');
        document.body.style.overflow = '';
      }

      var openers = root.querySelectorAll('[data-og-appt-open]');
      for (var i = 0; i < openers.length; i++) openers[i].addEventListener('click', openDialog);

      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-og-appt-close]')) closeDialog();
      });

      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) closeDialog();
      });
      dialog.addEventListener('close', function () { document.body.style.overflow = ''; });
      dialog.addEventListener('cancel', function () { document.body.style.overflow = ''; });

      renderDays();

      var stored = null;
      try { stored = sessionStorage.getItem(storeKey); } catch (e) {}

      if (successEl) {
        var slotOut = root.querySelector('[data-og-appt-success-slot]');
        if (slotOut && stored) { slotOut.textContent = stored; slotOut.hidden = false; }
        try { sessionStorage.removeItem(storeKey); } catch (e) {}
        openDialog();
      } else if (errorsEl) {
        if (stored) {
          if (slotField) slotField.value = stored;
          if (summaryText) summaryText.textContent = stored;
          if (summaryEl) summaryEl.hidden = false;
        }
        views(2);
        openDialog();
      }
    }

    function initAll() {
      var roots = document.querySelectorAll('.og-appt');
      for (var i = 0; i < roots.length; i++) initAppt(roots[i]);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector ? e.target.querySelector('.og-appt') : null;
      if (!root && e.target.classList && e.target.classList.contains('og-appt')) root = e.target;
      if (root) { root.dataset.ogApptInit = ''; initAppt(root); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opgeladen-product-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll('[data-og-phero]');
    roots.forEach((root) => {
      const variantBtns = root.querySelectorAll('[data-og-phero-variant]');
      const formInput = root.querySelector('[data-og-phero-form-variant]');
      const priceAmount = root.querySelector('[data-og-phero-price-amount]');
      const ctaPrice = root.querySelector('[data-og-phero-cta-price]');
      const cta = root.querySelector('[data-og-phero-cta]');
      const sectionId = root.getAttribute('data-og-phero-section-id');

      function selectVariant(btn) {
        if (btn.hasAttribute('disabled')) return;
        const id = btn.getAttribute('data-variant-id');
        const price = btn.getAttribute('data-variant-price');
        const priceRaw = btn.getAttribute('data-variant-price-raw');
        const available = btn.getAttribute('data-variant-available') === 'true';
        const title = btn.getAttribute('data-variant-title');

        variantBtns.forEach((b) => {
          b.classList.remove('og-phero__variant--active');
          b.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('og-phero__variant--active');
        btn.setAttribute('aria-checked', 'true');

        if (formInput) {
          formInput.value = id;
        }
        if (priceAmount && price) priceAmount.innerHTML = price;
        if (ctaPrice && price) ctaPrice.innerHTML = ' &middot; ' + price;
        if (cta) {
          if (!available) {
            cta.setAttribute('disabled', 'disabled');
          } else {
            cta.removeAttribute('disabled');
          }
        }

        document.dispatchEvent(new CustomEvent('og:phero:variant-change', {
          detail: { sectionId, id, price, priceRaw, available, title }
        }));
      }

      variantBtns.forEach((btn) => {
        btn.addEventListener('click', () => selectVariant(btn));
      });

      const mainImage = root.querySelector('[data-og-phero-main-image]');
      const thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-og-phero-thumb]'));
      let currentIndex = 0;

      function activateThumb(index) {
        const thumb = thumbs[index];
        if (!thumb || !mainImage) return;
        currentIndex = index;
        thumbs.forEach((t) => {
          t.classList.remove('og-phero__thumb--active');
          t.setAttribute('aria-current', 'false');
        });
        thumb.classList.add('og-phero__thumb--active');
        thumb.setAttribute('aria-current', 'true');
        const zoom = thumb.getAttribute('data-zoom-src');
        if (zoom) mainImage.setAttribute('data-zoom-src', zoom);
        const src = thumb.getAttribute('data-full-src');
        if (!src) return;
        mainImage.style.opacity = '0';
        const next = new Image();
        next.onload = () => {
          mainImage.src = src;
          requestAnimationFrame(() => {
            mainImage.style.opacity = '1';
          });
        };
        next.src = src;
      }

      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => activateThumb(index));
      });

      // Fotovergroting (lightbox): klik op de hoofdfoto opent een schermvullende
      // weergave met vorige/volgende, sluiten via kruis/achtergrond/Escape,
      // pijltjestoetsen en swipe. Slides komen uit de thumbnails, anders uit de
      // hoofdfoto zelf.
      const zoomTrigger = root.querySelector('[data-og-phero-zoom-trigger]');
      const lightbox = root.querySelector('[data-og-lightbox]');
      if (zoomTrigger && lightbox && mainImage) {
        let slides = thumbs
          .map((t) => t.getAttribute('data-zoom-src') || t.getAttribute('data-full-src'))
          .filter(Boolean);
        if (slides.length === 0) {
          const single = mainImage.getAttribute('data-zoom-src') || mainImage.getAttribute('src');
          if (single) slides = [single];
        }

        const lbImg = lightbox.querySelector('[data-og-lightbox-img]');
        const lbPrev = lightbox.querySelector('[data-og-lightbox-prev]');
        const lbNext = lightbox.querySelector('[data-og-lightbox-next]');
        const lbCounter = lightbox.querySelector('[data-og-lightbox-counter]');
        const closers = Array.prototype.slice.call(lightbox.querySelectorAll('[data-og-lightbox-close]'));
        const multi = slides.length > 1;
        let lbIndex = 0;
        let lastFocused = null;
        let bodyOverflow = '';

        if (!multi) {
          if (lbPrev) lbPrev.style.display = 'none';
          if (lbNext) lbNext.style.display = 'none';
          if (lbCounter) lbCounter.style.display = 'none';
        }

        // Naar <body> zodat geen enkele overflow/transform-ouder de overlay clipt.
        document.body.appendChild(lightbox);

        function render() {
          if (!lbImg) return;
          lbImg.src = slides[lbIndex];
          if (lbCounter && multi) lbCounter.textContent = (lbIndex + 1) + ' / ' + slides.length;
        }

        function focusables() {
          return [closers[0], multi ? lbPrev : null, multi ? lbNext : null].filter(Boolean);
        }

        function onKey(e) {
          if (e.key === 'Escape') {
            e.preventDefault();
            closeLb();
          } else if (e.key === 'ArrowLeft') {
            go(-1);
          } else if (e.key === 'ArrowRight') {
            go(1);
          } else if (e.key === 'Tab') {
            const f = focusables();
            if (f.length === 0) return;
            const first = f[0];
            const last = f[f.length - 1];
            if (e.shiftKey && document.activeElement === first) {
              e.preventDefault();
              last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
              e.preventDefault();
              first.focus();
            }
          }
        }

        function openLb() {
          lbIndex = Math.min(Math.max(currentIndex, 0), slides.length - 1);
          render();
          lastFocused = document.activeElement;
          bodyOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          lightbox.hidden = false;
          document.addEventListener('keydown', onKey);
          const f = focusables();
          if (f[0]) f[0].focus();
        }

        function closeLb() {
          lightbox.hidden = true;
          document.body.style.overflow = bodyOverflow;
          document.removeEventListener('keydown', onKey);
          if (lastFocused && lastFocused.focus) lastFocused.focus();
        }

        function go(delta) {
          if (!multi) return;
          lbIndex = (lbIndex + delta + slides.length) % slides.length;
          render();
        }

        zoomTrigger.addEventListener('click', openLb);
        zoomTrigger.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            openLb();
          }
        });
        if (lbPrev) lbPrev.addEventListener('click', () => go(-1));
        if (lbNext) lbNext.addEventListener('click', () => go(1));
        closers.forEach((c) => c.addEventListener('click', closeLb));

        let tx = 0;
        lightbox.addEventListener('touchstart', (e) => {
          tx = e.changedTouches[0].clientX;
        }, { passive: true });
        lightbox.addEventListener('touchend', (e) => {
          const dx = e.changedTouches[0].clientX - tx;
          if (Math.abs(dx) > 45) go(dx < 0 ? 1 : -1);
        }, { passive: true });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opgeladen-product-rekentool"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll('[data-og-prek]');
    roots.forEach((root) => {
      const consumption = root.querySelector('[data-og-prek-consumption]');
      const panels = root.querySelector('[data-og-prek-panels]');
      const toggle = root.querySelector('[data-og-prek-toggle]');
      const consumptionLabel = root.querySelector('[data-og-prek-consumption-label]');
      const panelsLabel = root.querySelector('[data-og-prek-panels-label]');
      const wpLabel = root.querySelector('[data-og-prek-wp-label]');
      const savings = root.querySelector('[data-og-prek-savings]');
      const payback = root.querySelector('[data-og-prek-payback]');

      const basePrice = parseFloat(root.getAttribute('data-og-prek-base-price')) || 1499;
      const capKwh = parseFloat(root.getAttribute('data-og-prek-cap-kwh')) || 10.8;
      const priceDyn = parseFloat(root.getAttribute('data-og-prek-price-dyn')) || 0.682;
      const priceFix = parseFloat(root.getAttribute('data-og-prek-price-fix')) || 0.60;
      const shiftMin = parseFloat(root.getAttribute('data-og-prek-shift-min')) || 0.34;
      const shiftMax = parseFloat(root.getAttribute('data-og-prek-shift-max')) || 0.90;
      const savingsCap = parseFloat(root.getAttribute('data-og-prek-savings-cap')) || 1733;
      const wpPerPanel = parseFloat(root.getAttribute('data-og-prek-wp-per-panel')) || 430;

      const nl = (n) => Math.round(n).toLocaleString('nl-NL');

      function updateFill(slider) {
        if (!slider) return;
        const min = parseFloat(slider.min) || 0;
        const max = parseFloat(slider.max) || 100;
        const val = parseFloat(slider.value) || 0;
        const pct = ((val - min) / (max - min)) * 100;
        slider.style.setProperty('--og-prek-fill', pct + '%');
      }

      function recalc() {
        const c = parseFloat(consumption.value);
        const p = parseFloat(panels.value);
        const dyn = toggle.classList.contains('og-prek__toggle--on');

        const wp = p * wpPerPanel;
        const pv = wp * 0.88;
        let shifted = Math.min(pv, c) * (shiftMax - shiftMin);
        shifted = Math.min(shifted, capKwh * 300);
        const kwhPrice = dyn ? priceDyn : priceFix;
        const s = Math.min(shifted * kwhPrice, savingsCap);
        const pb = s > 0 ? basePrice / s : 0;

        if (consumptionLabel) consumptionLabel.textContent = nl(c) + ' kWh';
        if (panelsLabel) panelsLabel.textContent = nl(p) + ' panelen';
        if (wpLabel) wpLabel.textContent = '≈ ' + nl(wp) + ' Wp';
        if (savings) savings.textContent = nl(s);
        if (payback) payback.textContent = (Math.round(pb * 10) / 10).toString().replace('.', ',');
      }

      function onSliderInput(slider) {
        return () => {
          updateFill(slider);
          recalc();
        };
      }

      if (consumption) {
        updateFill(consumption);
        consumption.addEventListener('input', onSliderInput(consumption));
      }
      if (panels) {
        updateFill(panels);
        panels.addEventListener('input', onSliderInput(panels));
      }
      if (toggle) toggle.addEventListener('click', () => {
        toggle.classList.toggle('og-prek__toggle--on');
        toggle.setAttribute('aria-pressed', toggle.classList.contains('og-prek__toggle--on') ? 'true' : 'false');
        recalc();
      });

      recalc();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opgeladen-product-sticky"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const bars = document.querySelectorAll('[data-og-psticky]');
    bars.forEach((bar) => {
      const variantInput = bar.querySelector('[data-og-psticky-variant]');
      const priceEl = bar.querySelector('[data-og-psticky-price]');
      const cta = bar.querySelector('.og-psticky__cta');

      let shown = false;
      const hero = document.querySelector('[data-og-phero]');
      const heroCta = document.querySelector('[data-og-phero-cta]');

      function update() {
        const vh = window.innerHeight || document.documentElement.clientHeight;
        let passed;
        if (heroCta) {
          // Toon de sticky zodra de koopknop in de hero niet (meer) in beeld is,
          // zodat er nooit een moment zonder zichtbare CTA is (mobiel en desktop).
          const r = heroCta.getBoundingClientRect();
          passed = !(r.top < vh - 40 && r.bottom > 0);
        } else if (hero) {
          passed = hero.getBoundingClientRect().bottom < 40;
        } else {
          passed = window.scrollY > 500;
        }
        if (passed && !shown) {
          bar.classList.add('og-psticky--visible');
          shown = true;
        } else if (!passed && shown) {
          bar.classList.remove('og-psticky--visible');
          shown = false;
        }
      }

      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();

      document.addEventListener('og:phero:variant-change', (e) => {
        const d = e.detail || {};
        if (variantInput && d.id) {
          variantInput.value = d.id;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (priceEl && d.price) priceEl.innerHTML = d.price;
        if (cta) {
          if (d.available === false) {
            cta.setAttribute('disabled', 'disabled');
          } else {
            cta.removeAttribute('disabled');
          }
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
